import Address from '@th-types/address.type';
import Picture from '@th-types/picture.type';

export interface IWorkerRankStats {
  confirmedJobsWorked: number | null;
  confirmedDaysWorked: number | null;
  confirmedJobUniqueCompanies: number | null;
  nonConfirmedJobsWorked: number | null;
  nonConfirmedDaysWorked: number | null;
  nonConfirmedJobUniqueCompanies: number | null;
}

export interface IWorkerData {
  id: number;
  address: Address;
  firstName: string;
  lastName: string;
  fullName: string;
  isPremium: boolean;
  profileImage?: Picture;
  rating: number;
  profileImageUrl: string;
  resumeId?: number;
  resumeName?: string;
  resumeUrl?: string;
  skills: Skill[];
  additionalPictures?: Pictures;
  linkedinUser?: string;
  instagramUser?: string;
  facebookUser?: string;
  cellPhone: string;
  email: string;
  twitterUser?: string;
  tiktokUser?: string;
  willingToTravel: boolean;
  travelLonger?: TravelLonger;
  travelPeriod?: TravelLonger;
  yearsInIndustry: number;
  monthsInIndustry: number;
  heightFeet: number;
  heightInches: number;
  birthday: Date;
  presentationVideoURL?: string;
  personalVideoId?: number | null;
  features?: WorkerFeature[];
  customUrl?: string;
  gender?: string;
  localMarketPosition?: number;
  localMarketTotal?: number;
  profileCompletedPercentage?: number;
  hasApp?: boolean;
  stats?: IWorkerRankStats;
  experienceLevel?: number;
}

export interface Pictures {
  apiName: string;
  pictures: Picture[];
}

export interface Skill {
  id: number;
  name: string;
}

export interface TravelLonger {
  value: string;
  label: string;
}

export enum TravelPeriods {
  UP_TO_3_MONTHS = 'Up to 3 Months or Less',
  UP_TO_6_MONTHS = 'Up to 6 Months or Less',
  UP_TO_9_MONTHS = 'Up to 9 Months or Less',
  UP_TO_1_YEAR_OR_MORE = 'Up to 1 Year or More',
}

export interface WorkerFeature {
  feature: string;
}

export type IWorkerBasicInfo = Omit<
  Pick<IWorkerData, 'cellPhone' | 'email' | 'profileImageUrl'>,
  'id'
> & {
  workerId: IWorkerData['id'];
  workerFullName: IWorkerData['fullName'];
  workerProfileImageUrl: IWorkerData['profileImageUrl'];
  workerCellphone: IWorkerData['cellPhone'];
  workerEmail: IWorkerData['email'];
};
